import { IHttpService } from "../HttpService";
import { formatBooleanValue, parseBooleanValue } from "../..";
import FormTypesGroupCategory, {
  IFormTypesGroupCategory
} from "../../model/formconfiguration/FormTypesGroupCategory";
import FormTypesGroup, {
  IFormTypesGroup
} from "../../model/formconfiguration/FormTypesGroup";

const FORM_TYPES_EXTENSION = "form-types";

export interface IFormTypesGroupCategoryService {
  getFormTypesGroupCategories(): Promise<any>;
  createFormTypesGroupCategory(
    formTypesGroupCategory: IFormTypesGroupCategory
  ): Promise<any>;
  updateFormTypesGroupCategory(
    formTypesGroupCategory: IFormTypesGroupCategory
  ): Promise<any>;
  getFormTypesGroups(formTypesGroupCategoryCode: String): Promise<any>;
  createFormTypesGroups(formTypesGroups: IFormTypesGroup[]): Promise<any>;
  removeFormTypesGroups(ids: number[]): Promise<any>;
}

const FormTypesGroupCategoryService = (
  httpService
): IFormTypesGroupCategoryService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api/codebooks";
  const _formTypesGroupCategoriesPath = "form-types-group-categories";

  let FormTypesGroupCategoryListMapper = (json = []) => {
    return json.map((item: any) => {
      let formTypesGroupCategory = FormTypesGroupCategory(item);
      formTypesGroupCategory.valid = formatBooleanValue(item.valid);
      return formTypesGroupCategory;
    });
  };

  let FormTypesGroupListMapper = (json = []) => {
    return json.map((item: any) => {
      return FormTypesGroup(item);
    });
  };

  let ParamsMapper = (formTypesGroupCategory: IFormTypesGroupCategory) => {
    return {
      ...formTypesGroupCategory,
      valid: parseBooleanValue(formTypesGroupCategory.valid)
    };
  };

  return {
    async getFormTypesGroupCategories() {
      const path = _http.buildPath(_baseUrl, _formTypesGroupCategoriesPath);
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return FormTypesGroupCategoryListMapper(responseJSON);
    },

    async createFormTypesGroupCategory(
      formTypesGroupCategory: IFormTypesGroupCategory
    ) {
      const path = _http.buildPath(_baseUrl, _formTypesGroupCategoriesPath);
      const response = await _http.post(path, {
        params: ParamsMapper(formTypesGroupCategory)
      });
      return _http.toText(response);
    },

    async updateFormTypesGroupCategory(
      formTypesGroupCategory: IFormTypesGroupCategory
    ) {
      const path = _http.buildPath(
        _baseUrl,
        _formTypesGroupCategoriesPath,
        formTypesGroupCategory.code
      );
      const response = await _http.put(path, {
        params: ParamsMapper(formTypesGroupCategory)
      });
      return _http.toText(response);
    },

    async getFormTypesGroups(formTypesGroupCategoryCode: String) {
      const path = _http.buildPath(
        _baseUrl,
        _formTypesGroupCategoriesPath,
        FORM_TYPES_EXTENSION
      );
      const response = await _http.get(path, {
        params: { formTypesGroupCategoryCode }
      });
      const responseJSON = await _http.toJSON(response);
      return FormTypesGroupListMapper(responseJSON);
    },

    async createFormTypesGroups(formTypesGroups: IFormTypesGroup[]) {
      const path = _http.buildPath(
        _baseUrl,
        _formTypesGroupCategoriesPath,
        FORM_TYPES_EXTENSION
      );
      const response = await _http.post(path, {
        params: formTypesGroups
      });
      return _http.toText(response);
    },

    async removeFormTypesGroups(ids: number[]) {
      const path = _http.buildPath(
        _baseUrl,
        _formTypesGroupCategoriesPath,
        FORM_TYPES_EXTENSION
      );
      const response = await _http.remove(path, {
        params: ids
      });
      return _http.toText(response);
    }
  };
};

export default FormTypesGroupCategoryService;
